// extracted by mini-css-extract-plugin
export default {"About":"About_About__Zqisy","content":"About_content__HLPpy"};